(function () {
  var STORAGE_KEY = 'antipodean_wishlist';
  var currentVariant = null;

  function trackWishlistAdd(data) {
    var endpoint = window.WISHLIST_TRACKER_URL;
    if (!endpoint) return;
    try {
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
    } catch (e) {}
  }

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }

  function setWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function addItem(item) {
    var items = getWishlist();
    if (!items.some(function (i) { return i.variantId === item.variantId; })) {
      items.push(item);
      setWishlist(items);
    }
    updateCount();
  }

  function removeItem(variantId) {
    setWishlist(getWishlist().filter(function (i) { return i.variantId !== variantId; }));
    updateCount();
  }

  function isInWishlist(variantId) {
    return getWishlist().some(function (i) { return i.variantId === variantId; });
  }

  function updateCount() {
    var count = getWishlist().length;
    var badge = document.querySelector('[data-wishlist-count]');
    if (badge) {
      badge.textContent = count > 0 ? '(' + count + ')' : '';
      badge.style.display = count > 0 ? '' : 'none';
    }
    document.querySelectorAll('[data-wishlist-button]').forEach(function (btn) {
      btn.classList.toggle('is-active', count > 0);
    });
  }

  function showToast(message) {
    var toast = document.getElementById('wishlist-toast');
    if (!toast) return;
    toast.querySelector('.wishlist-toast__text').textContent = message;
    toast.classList.add('wishlist-toast--visible');
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function () {
      toast.classList.remove('wishlist-toast--visible');
    }, 3000);
  }

  function initProductPage() {
    var btn = document.querySelector('[data-wishlist-btn]');
    var dataEl = document.querySelector('[data-wishlist-product]');
    if (!btn || !dataEl) return;

    var productData;
    try { productData = JSON.parse(dataEl.textContent); }
    catch (e) { return; }

    var compEl = document.querySelector('[data-component-data]');
    if (compEl) {
      try {
        var compData = JSON.parse(compEl.textContent);
        if (compData.selectedVariant) currentVariant = compData.selectedVariant;
      } catch (e) {}
    }

    function getVariantId() {
      var el = document.querySelector('[data-variants]');
      if (!el) return null;
      return el.value ? parseInt(el.value, 10) : null;
    }

    function updateHeartState(variantId) {
      btn.classList.toggle('is-active', variantId ? isInWishlist(variantId) : false);
    }

    updateHeartState(getVariantId());

    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.matches('[data-variants]')) return;
      var variantId = parseInt(e.target.value, 10);
      if (e.target.tagName === 'SELECT') {
        var opt = e.target.options[e.target.selectedIndex];
        currentVariant = { id: variantId, title: opt ? opt.text.split(' - ')[0].trim() : '' };
      } else {
        if (currentVariant) currentVariant.id = variantId;
        else currentVariant = { id: variantId, title: '' };
      }
      updateHeartState(variantId);
    });

    document.addEventListener('product:variant-change', function (e) {
      if (e.detail && e.detail.variant) {
        currentVariant = e.detail.variant;
        updateHeartState(currentVariant.id);
      }
    });

    btn.addEventListener('click', function () {
      var variantId = getVariantId();

      if (!variantId && !productData.hasOnlyDefaultVariant) {
        showSizeError(btn);
        return;
      }
      if (!variantId) return;

      if (isInWishlist(variantId)) {
        removeItem(variantId);
        btn.classList.remove('is-active');
        showToast('Removed from wishlist');
      } else {
        var variantTitle = currentVariant ? (currentVariant.title || '') : '';
        addItem({
          variantId: variantId,
          productId: productData.productId,
          title: productData.title,
          variantTitle: variantTitle,
          url: productData.url,
          image: productData.image,
          price: productData.price
        });
        trackWishlistAdd({
          title: productData.title,
          variantTitle: variantTitle,
          price: productData.price,
          productId: productData.productId,
          variantId: variantId,
          productType: productData.productType || '',
          url: window.location.href
        });
        btn.classList.add('is-active');
        showToast('Added to wishlist');
      }
    });
  }

  function showSizeError(btn) {
    var existing = document.querySelector('.wishlist-size-error');
    if (existing) existing.remove();
    var el = document.createElement('span');
    el.className = 'wishlist-size-error';
    el.textContent = 'Please select a size';
    btn.parentNode.insertBefore(el, btn.nextSibling);
    setTimeout(function () { if (el.parentNode) el.remove(); }, 3000);
  }

  function initWishlistPage() {
    var container = document.querySelector('[data-wishlist-page]');
    if (!container) return;
    renderWishlistPage(container);
  }

  function renderWishlistPage(container) {
    var items = getWishlist();
    if (items.length === 0) {
      container.innerHTML = '<p class="wishlist-empty">Your wishlist is empty. <a href="/collections/all">Continue shopping</a></p>';
      return;
    }

    var html = '<div class="wishlist-grid">';
    items.forEach(function (item) {
      var link = item.url + '?variant=' + item.variantId;
      html += '<div class="wishlist-card" data-wishlist-item="' + item.variantId + '">';
      html += '<a href="' + link + '" class="wishlist-card__image-wrap">';
      if (item.image) {
        html += '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" class="wishlist-card__image" loading="lazy">';
      } else {
        html += '<div class="wishlist-card__image-placeholder"></div>';
      }
      html += '</a>';
      html += '<div class="wishlist-card__body">';
      html += '<a href="' + link + '" class="wishlist-card__title">' + escapeHtml(item.title) + '</a>';
      html += '<span class="wishlist-card__price">' + escapeHtml(item.price) + '</span>';
      if (item.variantTitle && item.variantTitle !== 'Default Title') {
        html += '<span class="wishlist-card__variant">' + escapeHtml(item.variantTitle) + '</span>';
      }
      html += '<button class="wishlist-card__atc" data-wishlist-atc="' + item.variantId + '">ADD TO BAG</button>';
      html += '<button class="wishlist-card__remove" data-wishlist-remove="' + item.variantId + '">';
      html += '<span aria-hidden="true">&#215;</span> REMOVE';
      html += '</button>';
      html += '</div></div>';
    });
    html += '</div>';
    container.innerHTML = html;

    container.querySelectorAll('[data-wishlist-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addToCart(parseInt(btn.getAttribute('data-wishlist-atc'), 10), btn);
      });
    });

    container.querySelectorAll('[data-wishlist-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = parseInt(btn.getAttribute('data-wishlist-remove'), 10);
        removeItem(variantId);
        var card = container.querySelector('[data-wishlist-item="' + variantId + '"]');
        if (!card) return;
        card.style.transition = 'opacity 0.3s';
        card.style.opacity = '0';
        setTimeout(function () {
          card.remove();
          if (!container.querySelector('[data-wishlist-item]')) {
            container.innerHTML = '<p class="wishlist-empty">Your wishlist is empty. <a href="/collections/all">Continue shopping</a></p>';
          }
        }, 300);
      });
    });
  }

  function addToCart(variantId, btn) {
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'ADDING...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Failed'); });
      return r.json();
    })
    .then(function (lineItem) {
      btn.textContent = 'ADDED';
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var countEl = document.querySelector('[data-cart-count]');
        if (countEl) countEl.textContent = cart.item_count;
        var cartBtn = document.querySelector('[data-cart-button]');
        if (cartBtn && cart.item_count > 0) cartBtn.classList.remove('header__cart-button--is-zero');
        document.dispatchEvent(new CustomEvent('product:add-to-cart:success', { detail: { cart: cart, line_item: lineItem }, bubbles: true }));
        var cartDrawer = window.Core && Core.Components && Core.Components.getComponent('cart-drawer');
        if (cartDrawer) cartDrawer.open(btn, true);
      });
      setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 2000);
    })
    .catch(function () {
      btn.textContent = 'UNAVAILABLE';
      setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 2000);
    });
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateCount();
    initProductPage();
    initWishlistPage();
  });

  window.AntiWishlist = { getWishlist: getWishlist, addItem: addItem, removeItem: removeItem };
})();
